// extracted by mini-css-extract-plugin
module.exports = {"grid":"InviteDetailHeaderUI__grid___2VfwP","payment-container":"InviteDetailHeaderUI__payment-container___ZNfoT"};